var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackPaymentRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7148 1V7.66018",
    stroke: "#14142B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2276 2.21094H12.957C12.676 2.21094 12.4065 2.32257 12.2078 2.52128C12.0091 2.71999 11.8975 2.9895 11.8975 3.27051C11.8975 3.55153 12.0091 3.82103 12.2078 4.01974C12.4065 4.21845 12.676 4.33009 12.957 4.33009H14.4707C14.7517 4.33009 15.0212 4.44172 15.2199 4.64043C15.4187 4.83914 15.5303 5.10864 15.5303 5.38966C15.5303 5.67068 15.4187 5.94018 15.2199 6.13889C15.0212 6.3376 14.7517 6.44923 14.4707 6.44923H11.8975",
    stroke: "#14142B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05471 13.1094V10.6875M17.045 13.4121C17.045 13.4121 18.5587 13.1094 20.9805 11.8984C23.4024 10.6875 24.7055 12.7277 22.4942 14.0176C20.0723 15.4304 15.6524 17.3477 13.7149 17.3477C11.7774 17.3477 7.05471 13.4121 7.05471 15.5313V15.5313C7.05471 16.2001 6.51255 16.7422 5.84377 16.7422H3C1.89543 16.7422 1 15.8468 1 14.7422V11.4766C1 10.372 1.89543 9.47656 3 9.47656H5.84377C6.51255 9.47656 7.05471 10.0187 7.05471 10.6875V10.6875M17.045 13.4121C17.045 13.4121 16.8028 14.6231 15.834 14.6231C14.8653 14.6231 12.8067 14.6231 11.8985 14.6231M17.045 13.4121C17.1459 12.9076 17.045 11.8984 15.834 11.8984C14.6231 11.8984 13.5131 11.8984 13.1094 11.8984C12.6049 11.4948 11.1719 10.6875 9.47659 10.6875C7.78127 10.6875 7.15562 10.6875 7.05471 10.6875",
    stroke: "#14142B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackPaymentRequests);
export default __webpack_public_path__ + "static/media/BlackPaymentRequests.ec85c9b3d0d1d662c753f7303fff2c34.svg";
export { ForwardRef as ReactComponent };